module.exports = __webpack_public_path__ + "9e1cdf98ebc948ec7e9d66bf024cd199.svg";